import React, { useEffect } from "react"
import { Building } from "iconoir-react"
import VerifiedBusinessList from "./VerifiedBusinessList"

const BusinessOwnerTools: React.FC = () => {
  // const location = useLocation()

  useEffect(() => {
    document.title = "Vibrato - Business Tools"
  }, [])

  // // Determine which tab is active based on the current path
  // const getActiveTab = () => {
  //   if (location.pathname.includes("/ai-receptionists")) {
  //     return "ai-receptionists"
  //   }
  //   return "verified-businesses" // default tab
  // }

  const activeTab = "verified-businesses"

  return (
    <div className="h-full w-full p-6 md:p-8 flex flex-col gap-6">
      <div className="flex justify-between items-center flex-wrap gap-4">
        <div className="flex items-center gap-4">
          <div className="p-3 bg-purple-100 rounded-xl">
            <Building width="27" className="text-purple-600" />
          </div>
          <div>
            <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Business Tools</h1>
            <p className="text-gray-600">Manage your business presence and AI services</p>
          </div>
        </div>
      </div>
      {/*
      <nav className="flex border-b border-gray-200 dark:border-gray-700">
        <ul className="flex flex-wrap -mb-px text-sm font-medium text-center text-gray-500 dark:text-gray-400">
          <li className="mr-2">
            <Link
              to="/business-tools"
              className={`inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg ${
                activeTab === "verified-businesses"
                  ? "text-blue-600 border-blue-600 active dark:text-blue-500 dark:border-blue-500"
                  : "border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
              }`}
            >
              Verified Businesses
            </Link>
          </li>
          <li className="mr-2">
            <Link
              to="/business-tools/ai-receptionists"
              className={`inline-flex items-center justify-center p-4 border-b-2 rounded-t-lg ${
                activeTab === "ai-receptionists"
                  ? "text-blue-600 border-blue-600 active dark:text-blue-500 dark:border-blue-500"
                  : "border-transparent hover:text-gray-600 hover:border-gray-300 dark:hover:text-gray-300"
              }`}
            >
              AI Receptionists
            </Link>
          </li>
        </ul>
      </nav> */}

      <div className="bg-slate-50 p-4 md:p-6 rounded-xl border border-slate-200">
        <p className="text-slate-700">
          {activeTab === "verified-businesses"
            ? "Claim and verify your business listings to improve your online presence and connect with customers through Vibrato's platform."
            : "Set up AI receptionists to automatically handle incoming calls to your business with intelligent responses and task automation."}
        </p>
      </div>

      {/* Render the appropriate component based on active tab */}
      {activeTab === "verified-businesses" && <VerifiedBusinessList />}
      {/* {activeTab === "ai-receptionists" && <AIReceptionistList />} */}
    </div>
  )
}

export default BusinessOwnerTools
